// extracted by mini-css-extract-plugin
module.exports = {"center":"configuratorRoute-module__center___2LEJ4","info":"configuratorRoute-module__info____Pi-r"};